'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('react-intl-tel-input/dist/main.css');

require('./telephone.css');

var _base = require('../_base');

var _base2 = _interopRequireDefault(_base);

var _reactIntlTelInput = require('react-intl-tel-input');

var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);

require('react-intl-tel-input/dist/libphonenumber.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// https://www.npmjs.com/package/react-intl-tel-input / http://patw0929.github.io/react-intl-tel-input/


var GeckoFieldTelephone = function (_GeckoFieldBase) {
	_inherits(GeckoFieldTelephone, _GeckoFieldBase);

	_createClass(GeckoFieldTelephone, null, [{
		key: 'makeAccessibleFn',
		value: function makeAccessibleFn(ref) {
			try {
				var _setAttrs;

				var setAttrs = function setAttrs(el, attrs) {
					Object.keys(attrs).forEach(function (key) {
						return el.setAttribute(key, attrs[key]);
					});
				};

				var input = ref.tel;
				var dropdown = ref.flagDropDown;
				var button = dropdown.querySelector('.selected-flag');
				var listbox = dropdown.querySelector('.country-list');
				var options = function options() {
					return listbox.querySelectorAll('.country');
				};
				var getSelectedCountry = function getSelectedCountry(className) {
					return className.replace('iti-flag', '').trim();
				};

				setAttrs(button, (_setAttrs = {
					role: 'button'
				}, _defineProperty(_setAttrs, 'aria-label', 'Telephone Country Code'), _defineProperty(_setAttrs, 'aria-expanded', false), _defineProperty(_setAttrs, 'aria-haspopup', 'listbox'), _setAttrs));

				setAttrs(listbox, {
					role: 'listbox'
				});

				var listboxHasOpened = false;

				// List box opens and closes
				new MutationObserver(function (mutations) {
					mutations.forEach(function (mutation) {
						if (mutation.attributeName === 'class') {

							var expanded = !mutation.target.className.includes('hide');

							// Update aria-expanded on button when listbox opens and closes
							setAttrs(button, _defineProperty({}, 'aria-expanded', !mutation.target.className.includes('hide')));

							// Only apply on first open
							if (expanded && !listboxHasOpened) {
								options().forEach(function (option) {
									setAttrs(option, {
										role: 'option'
									});
								});

								// Remove divider as its invalid html
								(listbox.querySelector('.divider') || { remove: function remove() {} }).remove();

								listboxHasOpened = true;
							}
						}
					});
				}).observe(listbox, {
					attributes: true
				});

				// Country change/select
				new MutationObserver(function (mutations) {
					mutations.forEach(function (mutation) {
						if (mutation.attributeName === 'class') {

							options().forEach(function (option) {
								setAttrs(option, {
									selected: false
								});
							});

							var selectedOption = listbox.querySelector('li[data-country-code=' + getSelectedCountry(mutation.target.className) + ']');
							if (selectedOption) {
								setAttrs(selectedOption, {
									selected: true
								});
							}
						}
					});
				}).observe(button.querySelector('.iti-flag'), {
					attributes: true
				});
			} catch (err) {}
		}
	}]);

	function GeckoFieldTelephone(props) {
		_classCallCheck(this, GeckoFieldTelephone);

		var _this = _possibleConstructorReturn(this, (GeckoFieldTelephone.__proto__ || Object.getPrototypeOf(GeckoFieldTelephone)).call(this, props));

		_this.inputs = [{
			key: 'country_code'
		}, {
			key: 'number'
		}];

		_this.ref = _react2.default.createRef();
		return _this;
	}

	_createClass(GeckoFieldTelephone, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			GeckoFieldTelephone.makeAccessibleFn(this.ref.current);
		}
	}, {
		key: 'handleChange',
		value: function handleChange(status, value, data, number, id) {
			return this.props.handler.bind(this, this.field().key, this.prepareValue(value, data, number))();
		}
	}, {
		key: 'prepareValue',
		value: function prepareValue(value, data, number) {
			return {
				number: number,
				country_code: data.iso2
			};
		}
	}, {
		key: 'attrs',
		value: function attrs() {
			var _Object$assign;

			return {
				ref: this.ref,
				telInputProps: Object.assign((_Object$assign = {}, _defineProperty(_Object$assign, 'aria-label', this.renderAriaLabel()), _defineProperty(_Object$assign, 'required', this.isRequired()), _defineProperty(_Object$assign, 'aria-required', this.isRequired()), _Object$assign), this.renderAriaAttrs()),
				placeholder: this.config().placeholder,
				preferredCountries: this.config().preferredCountries || ['gb'],
				onlyCountries: this.config().onlyCountries || [],
				excludeCountries: this.config().excludeCountries || [],
				css: ['intl-tel-input', 'form-control'],
				nationalMode: false,
				format: true,
				utilsScript: 'libphonenumber.js',
				fieldId: this.renderId(),
				onPhoneNumberChange: this.handleChange.bind(this),
				onPhoneNumberBlur: this.handleBlur.bind(this),
				disabled: this.isDisabled(),
				value: this.jsonValue().number,
				autoComplete: 'tel'
			};
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(_reactIntlTelInput2.default, this.attrs());
		}
	}]);

	return GeckoFieldTelephone;
}(_base2.default);

exports.default = GeckoFieldTelephone;